import { createAction, props } from '@ngrx/store';

export const extensionPhoneDndChanged = createAction(
   '[Extension Phone Hub] Extension Phone DND Changed',
   props<{ extensionPhoneId: number; dndStatus: string | null }>()
);

export const extensionPhoneForwardCallsChanged = createAction(
   '[Extension Phone Hub] Extension Phone Forward Calls Changed',
   props<{
      extensionPhoneId: number;
      forwardExtensionId: number | null;
      forwardExternalNumber: string | null;
   }>()
);
